import classNames from "classnames";
import { useFormContext, useWatch } from "react-hook-form";
import styles from "./index.module.css";
import type { RequestReservationInputForm } from "@pages/shops/[uuid]/request_reservation/_useRequestReservationForm";
import type { FC, ReactNode } from "react";

type Props = {
  name: keyof RequestReservationInputForm;
  required: boolean;
  children: ReactNode;
};

export const ReservationFormSelect: FC<Props> = ({
  name,
  required,
  children,
}) => {
  const { register, control } = useFormContext<RequestReservationInputForm>();
  const value = useWatch({ control, name });
  return (
    <select
      {...register(name, { required })}
      className={classNames(styles.select, styles.date, !value && styles.empty)}
    >
      {children}
    </select>
  );
};
